import { render, staticRenderFns } from "./HeaderLabel.vue?vue&type=template&id=f7ee983e&scoped=true&"
import script from "./HeaderLabel.vue?vue&type=script&lang=js&"
export * from "./HeaderLabel.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLabel.vue?vue&type=style&index=0&id=f7ee983e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ee983e",
  null
  
)

export default component.exports